import React, { useState, useRef } from "react";
import axios from "axios";
import { IoPersonCircle } from "react-icons/io5";
import { FiSliders } from "react-icons/fi";
import { FaCamera } from "react-icons/fa";
import Footer from "../components/layout/Footer";
import ProfileHeader from "../components/layout/header/ProfileHeader";
import Table from "../components/Table";
import EditProfile from "../components/EditProfile";
import ResetPassword from "../components/ResetPassword";
import { IsAuth } from "../utils/Auth";
const ProfilePage = () => {
  const fileInput = useRef();
  const [openSign, setOpenSign] = useState(false);
  const [openLog, setOpenLog] = useState(false);
  const [profileImg, setProfileImg] = useState("/assests/profilePic.png");
  const signupClickHandler = () => {
    setOpenSign(!openSign);
  };
  const loginClickHandler = () => {
    setOpenLog(!openLog);
  };

  const OnChange = async (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setProfileImg(reader.result);
      }
    };
    reader.readAsDataURL(e.target.files[0]);

    // console.log(e.target.files[0]);

    const file = e.target.files[0];

    console.log(file);

    //get url from server
    const { url } = await fetch("/profileimg").then((res) => res.json());
    console.log(url);

    //post the image directly to the s3 bucket
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      body: file,
    });

    const imageUrl = url.split("?")[0];
    console.log(imageUrl);

    // console.log(e.target.files[0]);

    //get url from server
    // const { response } = await axios
    //   .get('/profileImg')
    //   .then((response) => console.log(response));

    // const url = response;
    // console.log(url);

    //upload image to s3 bucket
    // await axios.put(url, {
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //   },
    //   body: file,
    // });

    // const imageUrl = url.split('?')[0][1];
    // console.log(imageUrl);

    //  post request to my server for any extra data
    // };
  };

  return (
    <div id="profilePage" className="pt-5">
      <ProfileHeader />
      <div className="container-md-fluid py-5 my-5 ps-md-1">
        <div className="ps-4">
          <h4
            className="ps-md-5 ms-md-5 centerContent"
            style={{ fontWeight: "bold" }}
          >
            Edit Profile
          </h4>
        </div>
        <div className="pullDown justify-content-between mx-md-5 px-md-5 py-4 centerContent">
          <div className="d-flex gap-4 justify-content-center">
            <div className=" ps-4 d-flex flex-column">
              <div>
                <div class="imgHolder">
                  <img
                    src={profileImg}
                    alt="Profile Picture"
                    id="profileImg"
                    className=" img-fluid rounded-circle"
                  />
                </div>
                <input
                  type="file"
                  name="profileImg"
                  id="profileImg"
                  onChange={OnChange}
                  accept="image/*"
                  className="d-none"
                  ref={fileInput}
                />
                <label
                  htmlFor="profileImg"
                  className="d-flex labelCover"
                  style={{ cursor: "pointer" }}
                  onClick={() => fileInput.current.click()}
                >
                  <div className="d-flex gap-3">
                    <FaCamera color="#545558" size={22} />
                    <h6
                      style={{
                        textDecoration: "underline",
                        color: "#395998",
                      }}
                    >
                      Upload Profile
                    </h6>
                  </div>
                </label>
              </div>
            </div>

            <div className="d-md-flex gap-5 ps-4 profileborder ">
              <div className="d-flex flex-column pt-md-4">
                <div className="d-md-flex gap-4">
                  <h6 style={{ fontWeight: "bold" }}>User Name :</h6>
                  <h6>{IsAuth().name}</h6>
                </div>
                <div className="d-md-flex gap-5 py-2">
                  <h6 style={{ fontWeight: "bold" }}>Email ID :</h6>
                  <h6 style={{ textDecoration: "underline" }}>
                    {IsAuth().email}
                  </h6>
                </div>
                {/* <div className='d-md-flex gap-4'>
                  <h6 style={{ fontWeight: 'bold' }}>Phone No :</h6>
                  <h6 className='ps-md-2'>{IsAuth().phone}</h6>
                </div> */}
                <div className="d-md-flex gap-4 pt-5 mt-2 pb-0">
                  <h6
                    onClick={signupClickHandler}
                    style={{
                      textDecoration: "underline",
                      color: "#395998",
                      cursor: "pointer",
                    }}
                  >
                    Edit Profile
                  </h6>
                  <h6
                    onClick={loginClickHandler}
                    style={{
                      textDecoration: "underline",
                      color: "#395998",
                      cursor: "pointer",
                    }}
                  >
                    Update Password
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="justify-content-center d-flex">
            <div
              class="card text-center gapTop AccBalance"
              style={{
                backgroundColor: "#f7f7f7",
                borderRadius: "2rem",
                height: "10rem",
                width: "25rem",
              }}
            >
              <div class="card-body py-5">
                <h2
                  style={{ color: "#4F188C", fontWeight: "600" }}
                  class="card-title"
                >
                  $250.00
                </h2>
                <p class="card-text">Your Account Balance</p>
              </div>
            </div>
          </div>
        </div>
        <div className="pullDown2 gap-5 py-4">
          {/* <div className="d-md-flex gap-2 justify-content-center"> */}
          <div className="d-flex justify-content-center">
            <div
              class="card ps-md-4 me-md-5 pe-md-5 gapTop DepositFunds"
              style={{
                borderRadius: "2rem",
                // height: "9rem",
                width: "100%",
              }}
            >
              <div class="card-body p-4">
                <h4
                  style={{ color: "#4F188C", fontWeight: "600" }}
                  class="card-title"
                >
                  Deposit Funds
                </h4>
                <p style={{ marginBottom: "0.5rem" }} class="card-text">
                  Debit/Credit, Skrill. Crypto, Zelle,Stars & More
                </p>
                <p class="card-text">
                  Please contact live chat if you have questions
                </p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              class="card ps-4 gapTop2 DepositFunds"
              style={{
                borderRadius: "2rem",
                // height: "9rem",
                width: "100%",
              }}
            >
              <div class="card-body p-4">
                <h4
                  style={{ color: "#4F188C", fontWeight: "600" }}
                  class="card-title"
                >
                  Credit Funds
                </h4>
                <p style={{ marginBottom: "0.5rem" }} class="card-text">
                  Debit/Credit, Skrill. Crypto, Zelle,Stars & More
                </p>
                <p class="card-text">
                  Please contact live chat if you have questions
                </p>
              </div>
            </div>
          </div>
        </div>

        <Table />

        {/* <div class='row'>
          <h4>Nuværende kurser</h4>
          <div class='col-12 col-sm-12 col-lg-12'>
            <div class='table-responsive'>
              <table class='table'>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Table heading</th>
                    <th>Table heading</th>
                    <th>Table heading</th>
                    <th>Table heading</th>
                    <th>Table heading</th>
                    <th>Table heading</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                    <td>Table cell</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
      {openSign && <EditProfile closeModal={setOpenSign} />}
      {openLog && <ResetPassword closeModal={setOpenLog} />}
    </div>
  );
};
export default ProfilePage;
